import { Result } from '@empathy/search-types';
import { CoreState } from '../../../models';
import { isArrayEmptyOrNull } from '../../../utils/is-empty';
import { mapWishlistToResults } from '../../../utils/map-wishlist-to-results';
import { UpdateResultMutationPayload } from '../../search/mutations/update-result.mutation';
import { CORE_MUTATIONS_KEYS } from '../core.const';
import { CoreMutation } from '../core.interfaces';

export class WishlistMutation implements CoreMutation {
  mutations = {
    [CORE_MUTATIONS_KEYS.addToWishlist]: (localState: CoreState, { result: { id } }: UpdateResultMutationPayload) => {
      if (!localState.wishlist.includes(id)) {
        localState.wishlist.push(id);
      }
    },
    [CORE_MUTATIONS_KEYS.mapWishlistToExistingResults]: (localState: CoreState, existingResults: Array<Result[]>) => {
      existingResults.forEach(resultsContainer => {
        if (!isArrayEmptyOrNull(resultsContainer)) {
          mapWishlistToResults(localState.wishlist, resultsContainer);
        }
      });
    },
    [CORE_MUTATIONS_KEYS.removeFromWishlist]: (localState: CoreState, { result: { id } }: UpdateResultMutationPayload) => {
      const index = localState.wishlist.indexOf(id);
      localState.wishlist.splice(index, 1);
    },
    [CORE_MUTATIONS_KEYS.setWishlist]: (localState: CoreState, wishlist: string[]) => {
      localState.wishlist = wishlist;
    }
  };
}
